import React, { useState, useEffect } from "react";

import "react-native-gesture-handler";
import "regenerator-runtime/runtime";
import { useAssets } from "expo-asset";
import * as Font from "expo-font";
import { LinearGradient } from "expo-linear-gradient";
import { extendTheme, NativeBaseProvider } from "native-base";
import { LogBox } from "react-native";
import { enableScreens } from "react-native-screens";

import AppNavigator from "pianofunclub-crm/navigation/AppNavigator";
import { AuthProvider } from "pianofunclub-crm/providers/AuthProvider";
import { createRelayEnvironment } from "pianofunclub-crm/relay/createRelayEnvironment";
import appAssets from "pianofunclub-crm/utils/assets";

import { DataProvider } from "pianofunclub-shared/providers/DataProvider";
import { RelayProvider } from "pianofunclub-shared/providers/RelayProvider";
import LoadingScreen from "pianofunclub-shared/screens/LoadingScreen";
import themeExtensions from "pianofunclub-shared/theme";

LogBox.ignoreAllLogs();
console.error = (error) => error.apply;
console.warn = (warn) => warn.apply;

enableScreens();

const fetchFonts = () => {
  return Font.loadAsync({
    "Poppins-Black": require("pianofunclub-shared-assets/fonts/Poppins-Black.ttf"),
    "Poppins-BlackItalic": require("pianofunclub-shared-assets/fonts/Poppins-BlackItalic.ttf"),
    "Poppins-Bold": require("pianofunclub-shared-assets/fonts/Poppins-Bold.ttf"),
    "Poppins-BoldItalic": require("pianofunclub-shared-assets/fonts/Poppins-BoldItalic.ttf"),
    "Poppins-ExtraBold": require("pianofunclub-shared-assets/fonts/Poppins-ExtraBold.ttf"),
    "Poppins-ExtraBoldItalic": require("pianofunclub-shared-assets/fonts/Poppins-ExtraBoldItalic.ttf"),
    "Poppins-ExtraLight": require("pianofunclub-shared-assets/fonts/Poppins-ExtraLight.ttf"),
    "Poppins-ExtraLightItalic": require("pianofunclub-shared-assets/fonts/Poppins-ExtraLightItalic.ttf"),
    "Poppins-Italic": require("pianofunclub-shared-assets/fonts/Poppins-Italic.ttf"),
    "Poppins-Light": require("pianofunclub-shared-assets/fonts/Poppins-Light.ttf"),
    "Poppins-LightItalic": require("pianofunclub-shared-assets/fonts/Poppins-LightItalic.ttf"),
    "Poppins-Regular": require("pianofunclub-shared-assets/fonts/Poppins-Regular.ttf"),
    "Poppins-SemiBold": require("pianofunclub-shared-assets/fonts/Poppins-SemiBold.ttf"),
    "Poppins-SemiBoldItalic": require("pianofunclub-shared-assets/fonts/Poppins-SemiBoldItalic.ttf"),
  });
};

const AppRoot = (): React.ReactElement => {
  const [fontLoaded, setFontLoaded] = useState(false);

  const [assets] = useAssets(appAssets);

  useEffect(() => {
    fetchFonts().then(() => {
      setFontLoaded(true);
    });
  }, []);

  const nativeBaseConfig = {
    dependencies: {
      "linear-gradient": LinearGradient,
    },
  };

  const theme = extendTheme(themeExtensions);

  if (!fontLoaded || !assets) {
    return <LoadingScreen />;
  }

  return (
    <NativeBaseProvider config={nativeBaseConfig} theme={theme}>
      <AuthProvider>
        <RelayProvider createRelayEnvironment={createRelayEnvironment}>
          <DataProvider>
            <AppNavigator />
          </DataProvider>
        </RelayProvider>
      </AuthProvider>
    </NativeBaseProvider>
  );
};

export default AppRoot;
